import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { formatPrice } from 'settings/app/helpers'
import * as Styled from './Costs.styles'

/**
 * @returns {*}
 * @constructor
 */
const Costs = ({ userProfiles, sampleProfiles, onCalculateLinkClick }) => {
  const textContext = useContext(TextContext)

  const profileTextLine = (profile) => (
    <p>
      <span className={ 'profile_label' }>{`${ profile.label }:`}</span>
      <span className={ 'profile_value' }>
        {formatPrice({ price: profile.price })}
      </span>
    </p>
  )

  return (
    <Styled.CostsComponent>
      <div className={ 'profileContainer' }>
        {sampleProfiles.length > 0 && userProfiles.length <= 0 && (
          <>
            <p>{`${ textContext['costs.sampleProfiles'] }:`}</p>
            {sampleProfiles.map((profile) => profileTextLine(profile))}
          </>
        )}
        {userProfiles.length > 0 && (
          <>
            <p>{textContext['costs.userProfilesProfiles']}</p>
            {userProfiles.map((profile) => profileTextLine(profile))}
          </>
        )}
        <Link
          className={ 'more-link' }
          to={ '_blank' }
          onClick={ () => onCalculateLinkClick() }>
          {textContext['generalInformation.transparencyReport.Link']}
        </Link>
      </div>
      <div className={ 'investmentCostContainer' }>
        <p>
          <b>{textContext['costs.investment.title']}</b>
        </p>
        <p className={ 'copy' }>{textContext['costs.investment.description']}</p>
      </div>
    </Styled.CostsComponent>
  )
}

Costs.propTypes = {
  sampleProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  userProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  onCalculateLinkClick: PropTypes.func.isRequired,
}

export default Costs
